import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'next-i18next';

import { NS } from '@/constants';
import { CallToActionKind } from '@/types';

import CallToActionContainer from '@/components/common/callToAction/CallToActionContainer';
import FormField from '@/components/common/form/FormField';

import styles from './AdminCartItemPromotion.module.scss';
import { FIELD_TYPE } from '@/constants/form';

export const AdminCartItemPromotion = () => {
  const { t } = useTranslation();

  const { watch, setValue } = useFormContext();

  const promoPercent = watch('promoPercent');
  const promoValue = watch('promoValue');

  const handleChange = (field, value) => {
    setValue(field, value);
    if (field === 'promoPercent') {
      setValue('promoValue', '');
    } else {
      setValue('promoPercent', '');
    }
  };

  return (
    <>
      <div className={styles.container}>
        <FormField
          id="csr-promo-percent"
          label={`${t(`${NS.ADMIN}:checkout.csrPromotionPercent`)} %`}
          name="promoPercent"
          value={promoPercent}
          type={FIELD_TYPE.NUMBER}
          onChange={(e) => handleChange('promoPercent', e.target.value)}
          step="any"
          min="0"
        />
        <FormField
          id="csr-promo-value"
          label={`${t(`${NS.ADMIN}:checkout.csrPromotionValue`)} ${t('product.currency')}`}
          name="promoValue"
          value={promoValue}
          type={FIELD_TYPE.NUMBER}
          onChange={(e) => handleChange('promoValue', e.target.value)}
          step="any"
          min="0"
        />
      </div>
      <CallToActionContainer kind={CallToActionKind.SECONDARY} type={'submit'}>
        Appliquer
      </CallToActionContainer>
    </>
  );
};
